var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "openAI"
  }, [_c("section", {
    staticClass: "openAI__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "OPENAI数据开放平台",
      description: "同花顺OpenAI开放平台向泛金融合作伙伴提供行业领先的语音、图像、NLP等人工智能技术及海量的金融数据，\n      共享金融科技领域最新的应用场景和解决方案，帮助客户快速搭建金融产品及业务系统。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "openAI__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "openAI__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "openAI__statistics-wrapper"
  }, [_c("Statistics")], 1), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };